import { Paper, Divider, ListItem, ListItemText, Box } from "@mui/material";
import { QMScore } from "./QMScore";
import { QMResult } from "./QMResult";

type QMResultDetailsProps = {
	data: any;
};

type Question = {
	name: string;
	question: string;
	value: string;
};

export const QMResultDetails = (props: QMResultDetailsProps) => {
	const { data } = props;
	if (!data) return <Paper elevation={6} sx={{ width: "100%" }}></Paper>;

	const getValue = (questions: Question[], name: string) => {
		return questions.filter((question) => question.name === name)[0]?.value;
	};

	const getQuestion = (questions: Question[], name: string) => {
		return questions.filter((question) => question.name === name)[0]?.question;
	};

	const processQuestions = data.questions.filter(
		(question: Question) =>
			question.name.includes("Question") && !question.name.includes("Contact")
	);

	const contactHandlingQuestions = data.questions.filter((question: Question) =>
		question.name.includes("Contact Handling")
	);

	const responseDateValue = new Date(
		parseInt(data.responseDate)
	).toLocaleDateString();

	const contactDateValue = new Date(
		getValue(data.questions, "Contact Date")
	)?.toLocaleDateString();

	return (
		<Paper elevation={6} sx={{ width: "100%", padding: "0.5rem" }}>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr 1fr",
				}}
			>
				<ListItem>
					<ListItemText primary="Agent: " secondary={data.agent} />
				</ListItem>
				<ListItem>
					<ListItemText primary="Contact Date: " secondary={contactDateValue} />
				</ListItem>
				<ListItem>
					<ListItemText primary="Marked By: " secondary={data.marker} />
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Process: "
						secondary={getValue(data.questions, "Process")}
					/>
				</ListItem>
				<ListItem>
					<ListItemText primary="Review Date: " secondary={responseDateValue} />
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Contact Type"
						secondary={getValue(data.questions, "Contact Type")}
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="SR Number: "
						secondary={getValue(data.questions, "SR Number")}
					/>
				</ListItem>
			</Box>
			<Divider />
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
				}}
			>
				{processQuestions.map((question: Question) => (
					<ListItem key={question.name}>
						<ListItemText
							primary={getQuestion(data.questions, question.name)}
							secondary={getValue(data.questions, question.name)}
						/>
					</ListItem>
				))}
			</Box>
			<Divider />
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
				}}
			>
				{contactHandlingQuestions.map((question: Question) => (
					<ListItem key={question.name}>
						<ListItemText
							primary={getQuestion(data.questions, question.name)}
							secondary={getValue(data.questions, question.name)}
						/>
					</ListItem>
				))}
			</Box>
			<Divider />
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
				}}
			>
				<ListItem>
					<ListItemText
						primary="Notes: "
						secondary={getValue(data.questions, "Notes")}
					/>
				</ListItem>
				{getValue(data.questions, "Suggestions") && (
					<ListItem>
						<ListItemText
							primary="Suggestions: "
							secondary={getValue(data.questions, "Suggestions")}
						/>
					</ListItem>
				)}
			</Box>
			<Divider />
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
				}}
			>
				<QMResult result={data.result} />
				<QMScore score={data.averageScore} />
			</Box>
		</Paper>
	);
};
